import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import ShopMain from "../../layouts/main/ShopMain";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../../utils/global_const";
import { useParams } from "react-router-dom";
import { ProductContext } from "../../context/ProductContext";
import Header from "../../layouts/header/Header";
import BestSellerMain from "../../layouts/main/product/BestSellerMain";

const SEOConfig = {
  en: {
    title: "Best-Selling Nicotine Pouches | SnusCo Austria",
    description:
      "Browse the most popular nicotine pouches at SnusCo. Tried and loved by customers across Europe – strong flavors, fast delivery, and premium quality!",
    keywords:
      "best selling nicotine pouches, popular snus, top snus brands, strong nicotine pouches, SnusCo Austria, snus online Europe",
    url: "https://www.snusco.eu/en/neuheiten",
    images: ["https://www.snusco.eu/assets/bestseller-category-image.jpg"],
  },
  de: {
    title: "Meistverkaufte Nikotinbeutel | SnusCo Österreich",
    description:
      "Entdecken Sie unsere Bestseller – Nikotinbeutel, die unsere Kunden europaweit am meisten lieben. Starke Sorten, Top-Marken und schnelle Lieferung garantiert!",
    keywords:
      "Bestseller Snus, meistverkaufte Nikotinbeutel, beliebter Snus, starke Nikotinbeutel, SnusCo Österreich, Snus online kaufen",
    url: "https://www.snusco.eu/de/neuheiten",
    images: ["https://www.snusco.eu/assets/bestseller-category-image.jpg"],
  },
};

const BestSeller = () => {
  const { t, i18n } = useTranslation();
  const { loadBestSellersBackend, products } = useContext(ProductContext);

  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    if (!initialLoad) {
      // Proverava da li je ovo prvi put da se učitava
      loadBestSellersBackend();
      setInitialLoad(true); // Postavlja da je inicijalno učitavanje završeno
    }
  }, [initialLoad]);

  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <BestSellerMain />
      <Footer />
    </div>
  );
};

export default BestSeller;
